import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  ownerInputModal: {
    maxHeight: 'calc(100vh - 100px)',
    maxWidth: 'calc(100vw - 60px)',

    padding: SPACES.m,
  },
  content: {
    marginTop: SPACES.xxxl,
    width: '300px',
    height: '120px',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}))
